import React, { memo } from 'react'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { getNewCarrierStatus } from 'utils/carriers/getNewCarrierStatus'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import {
  CheckOutlineIcon,
  NotAvailableIcon,
  WarningFilledIcon,
  AlertFilledIcon,
} from 'transfix-icons'

const STATUSES = {
  active: {
    text: 'Active',
    IconComponent: CheckOutlineIcon,
    color: brandColors.info,
  },
  new: {
    text: 'Fresh',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  activated: {
    text: 'Activated',
    IconComponent: CheckOutlineIcon,
    color: brandColors.info,
  },
  pending: {
    text: 'Pending',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  application_submitted: {
    text: 'App Submitted',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  in_review: {
    text: 'In Review',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  expired_insurance: {
    text: 'Expired Insurance',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  probation: {
    text: 'Probation',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  other: {
    text: 'Other',
    IconComponent: WarningFilledIcon,
    color: brandColors.warning,
  },
  cancelled: {
    text: 'Canceled',
    IconComponent: NotAvailableIcon,
    color: brandColors.error,
  },
  conditional: {
    text: 'Conditional',
    IconComponent: AlertFilledIcon,
    color: brandColors.error,
  },
  out_of_service: {
    text: 'Out of Service',
    IconComponent: AlertFilledIcon,
    color: brandColors.error,
  },
  do_not_use: {
    text: 'Do not Use',
    IconComponent: AlertFilledIcon,
    color: brandColors.error,
  },
}

interface ICarrierStatusProps {
  status?: keyof typeof STATUSES
}

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(0.5),
  },
}))

const CarrierStatus = memo<ICarrierStatusProps>(({ status = 'other' }) => {
  const classes = useStyles()
  const isUseNewStateTagsMpEnabled = useFeatureFlag('useNewStateTagsMp')

  const { IconComponent, color, text } = STATUSES[status]

  return (
    <Box display='flex' alignItems='center' color={color}>
      <IconComponent className={classes.icon} size='medium' />
      <Typography component='div' variant='body2'>
        {getNewCarrierStatus(text, isUseNewStateTagsMpEnabled)}
      </Typography>
    </Box>
  )
})

export default CarrierStatus
